import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppStateService {
    private _initialized = false;

    isInitialized(): boolean {
        return this._initialized;
    }

    setInitialized(val: boolean) {
        this._initialized = val;
    }
}